import { render, staticRenderFns } from "./PendingReservationExtensions.vue?vue&type=template&id=559d03fe&scoped=true&"
import script from "./PendingReservationExtensions.vue?vue&type=script&lang=js&"
export * from "./PendingReservationExtensions.vue?vue&type=script&lang=js&"
import style0 from "./PendingReservationExtensions.vue?vue&type=style&index=0&id=559d03fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559d03fe",
  null
  
)

export default component.exports